import axios from "axios";

const isLocalHost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]"
);

const API_URL = isLocalHost
  ? "http://localhost:5000/api"
  : "https://shaheensapi.shaheenccyyc.com/api";

export const Axios = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});
